var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5H22V4.5C22 3.96957 21.7893 3.46086 21.4142 3.08579C21.0391 2.71071 20.5304 2.5 20 2.5H4C3.46957 2.5 2.96086 2.71071 2.58579 3.08579C2.21071 3.46086 2 3.96957 2 4.5V20.5C2 21.0304 2.21071 21.5391 2.58579 21.9142C2.96086 22.2893 3.46957 22.5 4 22.5H10V12.5C10 11.9696 10.2107 11.4609 10.5858 11.0858C10.9609 10.7107 11.4696 10.5 12 10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.5H22V20.5C22 21.0304 21.7893 21.5391 21.4142 21.9142C21.0391 22.2893 20.5304 22.5 20 22.5H10V28.5C10 29.0304 10.2107 29.5391 10.5858 29.9142C10.9609 30.2893 11.4696 30.5 12 30.5H28C28.5304 30.5 29.0391 30.2893 29.4142 29.9142C29.7893 29.5391 30 29.0304 30 28.5V12.5C30 11.9696 29.7893 11.4609 29.4142 11.0858C29.0391 10.7107 28.5304 10.5 28 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93b77ac19345fa2cc3a63af49e8c36ae.svg";
export { ForwardRef as ReactComponent };